import axios from "axios";
import { apiURI, authErrorRedirect } from "../../../common";
import _ from "lodash";
export async function handleProcurementMarkItemInactive(
  setErrors,
  setIsSubmitting,
  props,
  history,
  handleClose
) {
  setErrors({});
  setIsSubmitting(true);

  // Logic to update the sample request details with the edited item
  let newData = {
    sampleRequestID: props.detailsData.sampleRequestID,
    sampleItemID: props.data.sampleItemID,
  };

  await axios
    .post(`${apiURI}/form/procMarkItemInactive`, newData)
    .then(() => {
      handleClose();
      setIsSubmitting(false);
      window.location.reload(true);
    })
    .catch((response) => {
      console.log("error in axios form call react");
      setErrors({});
      setErrors(response.response.data);
      authErrorRedirect(response.response.data, history);
    });

  // eslint-disable-next-line no-console
}
